import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import ContainerInset from "@/components/container-inset";
import TransactionReportPage from "./_components/transaction-report-page";
import { transactionSearchSchema } from "./_data/transaction-report-constant";

export const Route = createFileRoute(
  "/(authenticated)/$merchantId/transactions/"
)({
  component: RouteComponent,
  validateSearch: zodValidator(transactionSearchSchema),
  remountDeps: ({ params }) => params.merchantId,
});

function RouteComponent() {
  return (
    <ContainerInset
      title="Transactions"
      breadcrumbs={[
        {
          title: "Transactions",
          href: "/",
        },
      ]}
    >
      <TransactionReportPage />
    </ContainerInset>
  );
}
